/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { BaseController } from '../../BaseController';

class DomainDeleteViewController extends BaseController {
    /** @ngInject */
    constructor(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log,
        $mdDialog, domainService, filterService) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.domainService = domainService;
        this.filterService = filterService;
        this.$mdDialog = $mdDialog;
        this.$log.debug('Controller \'DomainDeleteViewController\' loaded');
        // Angular Material does not support Angular $onInit hook for controllers yet
        // (see https://github.com/angular/material/issues/9259)
        // That's why it is simulated hereafter. This code shall be removed if the issue above is fixed (expected in
        // Angular Material 1.2.0)
        this.initialized = false;
        this.$onInit();
    }

    $onInit() {
        if (this.initialized) {
            this.$log.warn('DomainDeleteViewController.$onInit called twice: issue 9259 may have been fixed');
        } else {
            super.$onInit();

            this.domains = [];

            this.handleRestServiceCall(this.domainService.findEntities({
                params: this.filterService.buildSortingParam({sort: 'name'})
            }), domains => {
                this.domains = domains;
            }).finally(() => {
                this.formDisabled = false;
                this.initialized = true;
            });
        }
    }

    /**
     * Deletes a domain.
     *
     * @param {integer} id Domain ID.
     * @return {Promise} A promise which resolves when the delete is done.
     */
    delete() {
        this.formDisabled = true;
        return this.handleRestServiceCall(this.domainService.deleteEntity(this.domainId), () => {
            this.notificationService.pushMessage('ui.domain.deleted', this.configuration.NOTIFIER_LEVEL_INFO);
            this.$mdDialog.hide();
        }).finally(() => {
            this.formDisabled = false;
        });
    }

    cancel() {
        this.$mdDialog.hide();
    }
}

export { DomainDeleteViewController };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/component/DomainDeleteView.js